module.exports = __webpack_public_path__ + "./docs/img/vox-logo-purple.6ec489eb7461b0631274e1a0f489d07e.svg";